export default {
  getCurrentAnalyticsDashboard(state) {
    return state.current_analytics_dashboard
  }
}
